<template>
    <!--通知-->
  <div id="personnote">
    <h2 class="title">
      <a @click="back()" class="prev"></a>
      通知
    </h2>
    <div class="main">
      <!--
      <a href="">
        <img src="../../assets/img/personnote_img_avatar1.png" alt="">
        <div class="m">
          <h3>白老师</h3>
          <p>直播时间：2018.10.20-2018.10.22</p>
        </div>
      </a>
      <a href="">
        <img src="../../assets/img/personnote_img_avatar2.png" alt="">
        <div class="m">
          <h3>白老师</h3>
          <p>直播时间：2018.10.20-2018.10.22</p>
        </div>
      </a>
      <a href="">
        <img src="../../assets/img/personnote_img_avatar3.png" alt="">
        <div class="m">
          <h3>白老师</h3>
          <p>直播时间：2018.10.20-2018.10.22</p>
        </div>
      </a>
      -->
      <a href="" v-for="(item, index) in noteData" :key="index">
        <img :src="noteData.image ? noteData.image : defaultImage" alt="">
        <div class="m">
          <h3>{{item.name}}</h3>
          <p>直播时间：2018.10.20-2018.10.22</p>
        </div>
      </a>

    </div>
  </div>
</template>

<script>
export default {
  name: 'PersonNote',
  data () {
    return {
      noteData: {},
      defaultImage: require('../../assets/img/personnote_img_avatar3.png')
    }
  },
  mounted () {
    this.getExamSection()
  },
  methods: {
    getExamSection () {
      let data = {
      }
      this.$axios({
        method: 'GET',
        url: '/api/app/v1/get_home_notice',
        params: data,
        headers: {
          'sign': this.$encryption(data, this.$store.state.token, this.$store.state.uid)
        }
      })
        .then(res => {
          console.log(res)
          if (res.data.errcode === 200) {
            this.noteData = res.data.data
            console.log(this.videoList)
          } else alert(res.data.message)
        })
        .catch(err => {
          console.log(err)
        })
    },
    back () {
      if (window.history.length <= 1) {
        this.$router.push({path: '/'})
      } else {
        this.$router.go(-1)
      }
    }
  }
}
</script>

<style scoped lang="stylus">
  #personnote
    .title
      position: relative
      height: 1.08rem
      line-height: .8rem
      background-color: transparent
      padding: .14rem .16rem
      font-size: .32rem
      color: #050505
      font-weight: 600
      text-align: center
      -webkit-box-sizing: border-box
      -moz-box-sizing: border-box
      box-sizing: border-box
      a.prev
        position: absolute
        top: .14rem
        left: .16rem
        display: block
        width: .8rem
        height: .8rem
        background-color: #fff
        -webkit-border-radius: 50%
        -moz-border-radius: 50%
        border-radius: 50%
        &::before
          content: ""
          position: absolute
          top: .3rem
          left: .32rem
          display: block
          width: .20rem
          height: .20rem
          border-left: .03rem solid #050505
          border-bottom: .03rem solid #050505
          -webkit-transform: rotate(45deg)
          -moz-transform: rotate(45deg)
          -ms-transform: rotate(45deg)
          -o-transform: rotate(45deg)
          transform: rotate(45deg)
    .main
      padding: 0 .4rem
      -webkit-box-sizing: border-box
      -moz-box-sizing: border-box
      box-sizing: border-box
      a
        display: flex
        justify-content: flex-start
        align-items: center
        width: 6.7rem
        height: 1.2rem
        margin: .24rem 0 .48rem
        img
          width: 1.2rem
          height: 1.2rem
          margin-right: .2rem
          -webkit-border-radius: 50%
          -moz-border-radius: 50%
          border-radius: 50%
        div.m
          h3
            margin-bottom: .04rem
            font-size: .32rem
            color: #333
          p
            font-size: .22rem
            color: #9DA4B3
</style>



// WEBPACK FOOTER //
// src/components/personal/PersonNote.vue